import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import PercentFieldPreview from '@sprinx/react-mui-fields/PercentFieldPreview';
import NumberFieldPreview from '@sprinx/react-mui-fields/NumberFieldPreview';
import TextFieldPreview from '@sprinx/react-mui-fields/TextFieldPreview';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { isAuthenticatedState } from '../../../api/appState';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface ProductDetailOtherPricesProps extends StandardDivProps<ProductDetailOtherPricesClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailOtherPricesClassKey = 'root' | 'field';

const themeSettings = { name: 'ProductDetailOtherPrices' };
const useStyles = makeStyles(
  (theme) =>
    createStyles<ProductDetailOtherPricesClassKey, {}>({
      root: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
          width: '100%',
          maxWidth: '258px',
        },
      },
      field: {
        width: 'auto',
        flexDirection: 'column',
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginRight: 0,
          padding: theme.spacing(0, 1),
        },
      },
    }),
  themeSettings,
);

const ProductDetailOtherPrices = React.forwardRef<HTMLDivElement, ProductDetailOtherPricesProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    // const currency = useRecoilValue(currencyState);
    const isAuthenticated = useRecoilValue(isAuthenticatedState);
    // const getPrice = useMulticurrencyToPrice(currency);
    // const customerRegion = useRecoilValue(customerRegionState);
    const t = useTranslateWithFallback();

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <TextFieldPreview
          label={t('common/code')}
          value={product.sku || ''}
          size='small'
          alignLabel
          className={clsx(classes.field)}
        />
        <NumberFieldPreview
          label={t('productPage/minOrderableQuantity')}
          value={product.quantityStep}
          size='small'
          decimalPrecision={0}
          alignLabel
          className={clsx(classes.field)}
          // className={clsx(classes.field, classes.label)}
        />
        <TextFieldPreview
          label={t('common/unit')}
          value={product.unit}
          size='small'
          className={clsx(classes.field)}
          // className={clsx(classes.field, classes.label)}
          alignLabel
        />
        {/* <TextFieldPreview
          label={t('cataloguePage/item/package')}
          value={(customerRegion === 'SK' ? product.extra?.packSizeTextSK : product.extra?.packSizeTextCZ) || ''}
          size='small'
          align='right'
          alignLabel
          className={clsx(classes.field, classes.label)}
        /> */}
        {isAuthenticated && (
          <PercentFieldPreview
            label={t('common/vat')}
            value={product?.taxInfo?.value || 0}
            size='small'
            className={clsx(classes.field)}
            alignLabel
          />
        )}
        {/* {product.msiPriceWithTax && (
          <PriceFieldPreview
            label={t('common/vatDMIC')}
            value={getPrice(product.msiPriceWithTax)}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )}
        {product.msrPriceWithTax && (
          <PriceFieldPreview
            label={t('common/vatDMOC')}
            value={getPrice(product.msrPriceWithTax)}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )}
        {product.priceOriginalWithTax && (
          <PriceFieldPreview
            label={t('common/basePriceWithTax')}
            value={product.priceOriginalWithTax}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )}
        {product.priceOriginal && (
          <PriceFieldPreview
            label={t('common/basePriceWithoutTax')}
            value={product.priceOriginal}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )} */}
      </div>
    );
  },
);

ProductDetailOtherPrices.displayName = 'ProductDetailOtherPrices';

export default withThemeProps(themeSettings)(ProductDetailOtherPrices);
